import { AppIntegrationDetails } from "models";

/**
 * Do they have a linked integration
 */
export const hasLinkedIntegration = (data: AppIntegrationDetails): boolean => {
    const integrations = [
        data?.lacrm?.isLinked,
        data?.jobber?.isLinked,
        data?.servicetitan?.isLinked,
        data?.serviceminder?.isLinked,
        data?.fieldpulse?.isLinked,
        data?.housecallpro?.isLinked,
        data?.surefire?.isLinked,
        data?.webhook?.isLinked,
        data?.boberdoo?.isLinked,
        data?.free2grow?.isLinked,
        data?.leadperfection?.isLinked,
    ];

    return integrations.some(Boolean);
}